export default "__VITE_ASSET__CwnvQNXI__"